import React from "react";
import Grid from "@mui/material/Grid2";
import TestimonialTable from "./TestimonialTable";

function Testimonial() {
  return (
    <>
      <Grid size={12}>
        <TestimonialTable />
      </Grid>
    </>
  );
}

export default Testimonial;
